import { ModelApiService } from './BaseApiService'

export default class FeaturesApiService extends ModelApiService {
  constructor() {
    super('features')
  }

  async getAllFeatureFlags() {
    return await this.get()
  }

  async getFeatureFlag(featureName) {
    return await this.get(`${featureName}`)
  }
}
